module.exports = __webpack_public_path__ + "static/news-tab-app-cover-b9ba85841db4298ff154768ef3f76085.png";